const algoliasearch = require('algoliasearch/lite');

// Added some snippets of code here that are currently repeated in a few components:
// InstructorBioDynamic, DynamicProductList, CourseRecommendations, ConnectedSearchPage, search.js

// snippets like this are also common, would it be worthwhile standardising and using it as a util?
// const searchHelper = algoliasearchHelper(
//   searchClient,
//   indexName,
//   algoliaSearchParams,
// );

// initialize Algolia workers
function initializeSearchClient() {
  return algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  );
}

function getLocationRestrictionFilter(userCountry) {
  return `NOT blocked_in:"${userCountry}" AND (allowed_in:"null" OR allowed_in:"${userCountry}")`;
}

// There are currently lots of different ways filter query strings are built
// I'm wondering if it's possible (and worth it) to have a generic filter query string builder
// that handles filters passed to it dynamically
function getSkillsFilter(category, subcategory, skill) {
  if (category) {
    return `skills.category:"${category}"`;
  }
  if (subcategory) {
    return `skills.subcategory:"${subcategory}"`;
  }
  if (skill) {
    return `skills.skill:"${skill}"`;
  }
  return '';
}

module.exports = {
  initializeSearchClient,
  getLocationRestrictionFilter,
  getSkillsFilter,
};
